import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HeaderActionEventFromHeader, ORDERS_HEADER_EVENTS } from './orders-header-events.model';

/**
 * Orders ← Header action consumer.
 * Listens for header user actions (filter, refresh).
 */
@Service({ autoProvided: false })
export class OrdersHeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly headerAction$ = this.eventBus.on$<HeaderActionEventFromHeader>(ORDERS_HEADER_EVENTS.HEADER_ACTION).pipe(
		filter(Boolean),
		distinctUntilChanged((prev, curr) => prev.id === curr.id)
	);
}
